module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAA4klEQVR42u2TPQrCQBSE03gNwWt4B09gm97OwhNY2FrpKSxsLQQbo7HQgKggSDTRhA3R/Jpk9AVyg4XdIgMDy8wWH+/xFLPRhsyuAWtA4YBWs6PJbAUcVeRxaZ7iAviNn/AfM0TejkxvyuQAjH0DWeqWkwvdFSKm0Zsy6mQAPCBPPVow2HXy95RiyqgTC1jkCd7WHJUCZ4mQrVGJOvojdIJJcAGJ1mvv+7CNASK2qTo5jiT5nPE6DnHXVZhbFc5phDS8yXPFJDqOLGXIEgeRp4OXlLHR02S20l20ILNrwBpQtH8yDhWc89HQ3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/tj.png
// module id = 939
// module chunks = 0